import React, { useState, useEffect } from "react";
import { useHistory, Redirect } from "react-router-dom";

// Chakra imports
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Icon,
  Link,
  Switch,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import signInImage from "assets/img/signInImage.png";
import { FaApple, FaFacebook, FaGoogle } from "react-icons/fa";
import verifyCode from "api/authenticate/verify";
import NiceButton from "components/NiceButton/NiceButton.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "assets/css/style.css";

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const bgForm = useColorModeValue("white", "navy.800");
  const titleColor = useColorModeValue("gray.700", "blue.500");
  const colorIcons = useColorModeValue("gray.700", "white");
  const bgIcons = useColorModeValue("trasnparent", "navy.700");
  const bgIconsHover = useColorModeValue("gray.50", "whiteAlpha.100");
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  function send(e) {
    e.preventDefault();

    if (code.length != 5) {
      return toast.error("کد وارد شده صحیح نیست.", {
        position: "bottom-right"
      })
    }
    let mobileNumber = localStorage.getItem('mobileNumber')
    setIsLoading(true)
    verifyCode(mobileNumber, code).then((result) => {
      localStorage.removeItem("mobileNumber")
      localStorage.setItem('token', result.data.token)
      window.location = "/admin/dashboard";
    }).catch((err) => {
      console.error(err)
      if (err.response.data.code == -6)
        toast.error("کد وارد شده صحیح نیست.", {
          position: "bottom-right"
        })
       else if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsLoading(false)
    })
  }
  useEffect(() => {
    let mobileNumber = localStorage.getItem('mobileNumber')
    if (!mobileNumber) {
      window.location = "/auth/sendCode";
      return (<div></div>)
    }
    let token = localStorage.getItem('token')
    if (token) {
      window.location = "/auth/dashboard";
      return (<div></div>)
    }
  }, [])
  return (
    <Flex position='relative' mb='40px'>
      <Flex
        minH={{ md: "500px" }}
        h={{ sm: "initial", md: "75vh", lg: "85vh" }}
        w='100%'
        maxW='1044px'
        mx='auto'
        justifyContent='space-between'
        mb='20px'
        pt={{ md: "0px" }}>
        <Flex
          w='100%'
          h='100%'
          alignItems='center'
          justifyContent='center'
          mb='60px'
          mt={{ base: "50px", md: "20px" }}>
          <Flex
            zIndex='2'
            direction='column'
            w='445px'
            background='transparent'
            borderRadius='15px'
            p='40px'
            mx={{ base: "100px" }}
            m={{ base: "20px", md: "auto" }}
            bg={bgForm}
            boxShadow={useColorModeValue(
              "0px 5px 14px rgba(0, 0, 0, 0.05)",
              "unset"
            )}>
            <FormControl>

              <FormLabel ms='4px' fontSize='sm' fontWeight='normal' textAlign="right">
                کد پیامک شده
              </FormLabel>
              <Input
                value={code} onChange={e => setCode(e.target.value)}
                variant='auth'
                fontSize='sm'
                ms='4px'
                textAlign="right"
                type='text'
                placeholder=' کد پیامک شده را وارد کنید'
                mb='24px'
                size='lg'
              />

              <NiceButton
                isLoading={isLoading}
                onClick={send}
                fontSize='md'
                variant='dark'
                fontWeight='bold'
                w='100%'
                h='45'
                mb='24px'>
                تایید
              </NiceButton>
            </FormControl>
            <Flex
              flexDirection='column'
              justifyContent='center'
              alignItems='right'
              maxW='100%'
              mt='0px'>
              <Text color={textColor} fontWeight='medium' fontSize='xs'>
                <span>کد را دریافت نکردید؟ {" "}</span>
                <strong><a href='/auth/sendcode'>مجددا ارسال شود</a></strong>
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Box
          overflowX='hidden'
          h='100%'
          w='100%'
          left='0px'
          position='absolute'
          bgImage={signInImage}>
          <Box
            w='100%'
            h='100%'
            bgSize='cover'
            bg='blue.500'
            opacity='0.8'></Box>
        </Box>
      </Flex>
     
    </Flex>
  );
}

export default SignIn;
